import { useSelector } from "react-redux";
import { Routes, Route, Navigate } from "react-router-dom";
import PublicRoutes from "./routes/PublicRoutes";
import PrivateRoutes from "./routes/PrivateRoutes";
import NotFound from "./views/notFound/NotFound";
import { CssBaseline, StyledEngineProvider } from "@mui/material";
import { ToastContainer } from "react-toastify";
import NavigationScroll from "./layout/NavigationScroll";
import "react-datepicker/dist/react-datepicker.css";
import './assets/scss/admin.scss';
import Loading from './ui-component/Loading/Loading';
const App = () => {
  const isLoggedin = useSelector((state) => state?.admin?.isLoggedIn);

  const handleHomeRoute = () => (isLoggedin ? "/admin/dashboard" : "/login");

  return (
    <StyledEngineProvider injectFirst>
      <CssBaseline />
      <NavigationScroll>
        <Loading />
        <ToastContainer autoClose={5000} limit={1} />
        <Routes>
          {/* Public Routes */}
          {PublicRoutes.map((route, index) => (
            <Route key={index} path={route.path} element={route.element} />
          ))}

          {/* Private Routes */}
          {isLoggedin &&
            PrivateRoutes.map((route, index) => (
              <Route key={index} path={route.path} element={route.element}>
                {route.children?.map((child, i) => (
                  <Route key={i} index={child.index} path={child.path} element={child.element} />
                ))}
              </Route>
            ))}

          {/* Redirect root */}
          <Route path="/" element={<Navigate to={handleHomeRoute()} />} />

          {/* 404 */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </NavigationScroll>
    </StyledEngineProvider>
  );
};

export default App;
